import styled from 'styled-components'

import Text from './Text'

const defaultValues = {
  as: 'h2',
  fontSize: ['26px', '36px'],
  fontFamily: 'Arquitecta',
  letterSpacing: 2,
  lineHeight: '105%',
  fontWeight: 'black',
  textTransform: 'uppercase'
}

const Title = styled(Text)``

Title.defaultProps = {
  ...defaultValues
}

export {
  defaultValues,
  Title
}
